import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../ui-inlined-svg/ui-inlined-svg';
import iconStyle from './ui-header-icon-notification.css?inline';

const CName = 'ui-header-icon-notification';

@customElement(CName)
export class UIHeaderIconNotification extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  @property() showDot = false;

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/header-icon-notification.svg', import.meta.url).href;
    return html`<ui-inlined-svg .defer=${true} .src=${assetUrl}></ui-inlined-svg> ${
      this.showDot ? html`<div class="dot"></div>` : nothing
    }`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIHeaderIconNotification;
  }
}
